import { queryClient, QueryClientProvider } from '../query/queryClient';
import React from 'react';
export function QueryProvider({ children, }) {
    return React.createElement(QueryClientProvider, { client: queryClient }, children);
}
//# sourceMappingURL=QueryProvider.js.map